// Actions
import { RECEIVE_PROGRAMS, REQUEST_ERROR } from './actions';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newState = state;

  switch (action.type) {
    case RECEIVE_PROGRAMS:
      newState = action.program;
      break;

    case REQUEST_ERROR:
    default:
      break;
  } // Return the new state.


  return newState;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvcmVkdWNlci5qcyJdLCJuYW1lcyI6WyJSRUNFSVZFX1BST0dSQU1TIiwiUkVRVUVTVF9FUlJPUiIsInN0YXRlIiwiYWN0aW9uIiwibmV3U3RhdGUiLCJ0eXBlIiwicHJvZ3JhbSJdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQSxTQUFTQSxnQkFBVCxFQUEyQkMsYUFBM0IsUUFBZ0QsV0FBaEQ7QUFFQSxnQkFBZSxZQUE2QjtBQUFBLE1BQTVCQyxLQUE0Qix1RUFBcEIsRUFBb0I7QUFBQSxNQUFoQkMsTUFBZ0IsdUVBQVAsRUFBTztBQUMxQyxNQUFJQyxRQUFRLEdBQUdGLEtBQWY7O0FBRUEsVUFBUUMsTUFBTSxDQUFDRSxJQUFmO0FBQ0UsU0FBS0wsZ0JBQUw7QUFDRUksTUFBQUEsUUFBUSxHQUFHRCxNQUFNLENBQUNHLE9BQWxCO0FBQ0E7O0FBRUYsU0FBS0wsYUFBTDtBQUNBO0FBQ0U7QUFQSixHQUgwQyxDQWExQzs7O0FBQ0EsU0FBT0csUUFBUDtBQUNELENBZkQiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBBY3Rpb25zXG5pbXBvcnQgeyBSRUNFSVZFX1BST0dSQU1TLCBSRVFVRVNUX0VSUk9SIH0gZnJvbSAnLi9hY3Rpb25zJztcblxuZXhwb3J0IGRlZmF1bHQgKHN0YXRlID0ge30sIGFjdGlvbiA9IHt9KSA9PiB7XG4gIGxldCBuZXdTdGF0ZSA9IHN0YXRlO1xuXG4gIHN3aXRjaCAoYWN0aW9uLnR5cGUpIHtcbiAgICBjYXNlIFJFQ0VJVkVfUFJPR1JBTVM6XG4gICAgICBuZXdTdGF0ZSA9IGFjdGlvbi5wcm9ncmFtO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlIFJFUVVFU1RfRVJST1I6XG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgLy8gUmV0dXJuIHRoZSBuZXcgc3RhdGUuXG4gIHJldHVybiBuZXdTdGF0ZTtcbn07XG4iXX0=